import React from "react";
import { useSingleDeviceQuery } from "../../../../../store/okta/userSlice";
import { useParams } from "react-router-dom";
import { formattedDateTime } from "../../../../../utils";
import { Divider } from "../../../../atoms/divider";
import { Breadcrumb } from "../../../../atoms/breadcrumb";
import { Table } from "../../../../atoms/table";
import { Skeleton } from "../../../../atoms/skeleton";
import { PAGE_NAME, ROUTE } from "../../../../../constants/constants";

const SingleOktaDevice = () => {
    const pageClassName = "p-singleOktaDevice";
    const { id } = useParams<{ id: string }>();
    const { data, isLoading } = useSingleDeviceQuery({ id });

    const tableHeader = [
        {
            title: "Serial",
            dataIndex: "id",
            isSortable: false,
        },
        {
            title: "First Name",
            dataIndex: "firstName",
            isSortable: true,
        },
        {
            title: "Last Name",
            dataIndex: "lastName",
            isSortable: true,
        },
        {
            title: "Email",
            dataIndex: "email",
            isSortable: true,
        },
        {
            title: "Number of Devices",
            dataIndex: "numberOfDevices",
            isSortable: true,
        },
    ];

    return (
        <div className={pageClassName}>
            <Breadcrumb />
            <p className={`${pageClassName}__title`}>{PAGE_NAME.OKTA_DEVICE_INFO}</p>
            <div className={`${pageClassName}__container`}>
                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        Device ID
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? (
                            <Skeleton height="small" />
                        ) : (
                            data?.result?.deviceId ?? "-"
                        )}
                    </p>
                </div>
                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        Device Name
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? (
                            <Skeleton height="small" />
                        ) : (
                            data?.result?.name ?? "-"
                        )}
                    </p>
                </div>
                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>Model</p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? (
                            <Skeleton height="small" />
                        ) : (
                            data?.result?.model ?? "-"
                        )}
                    </p>
                </div>
                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        Manufacturer
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? (
                            <Skeleton height="small" />
                        ) : (
                            data?.result?.manufacturer ?? "-"
                        )}
                    </p>
                </div>
                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        OS Version
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? (
                            <Skeleton height="small" />
                        ) : (
                            data?.result?.osVersion ?? "-"
                        )}
                    </p>
                </div>

                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>Platform</p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? (
                            <Skeleton height="small" />
                        ) : (
                            data?.result?.platform ?? "-"
                        )}
                    </p>
                </div>

                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>Status</p>
                    <p className={`${pageClassName}__container__item__status ${data?.result?.status === "ACTIVE" ? pageClassName + '__container__item__status--active' : pageClassName + '__container__item__status--inactive'}`}>
                        {isLoading ? (
                            "-"
                        ) : (
                            data?.result?.status ?? "-"
                        )}
                    </p>
                </div>

                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        Number of Users
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? (
                            <Skeleton height="small" />
                        ) : (
                            data?.result?.numberOfUsers ?? 0
                        )}
                    </p>
                </div>

                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>Created</p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? (
                            <Skeleton height="small" />
                        ) : data?.result?.createdAt ? (
                            formattedDateTime(data?.result?.createdAt)
                        ) : (
                            "-"
                        )}
                    </p>
                </div>
                <div className={`${pageClassName}__container__item`}>
                    <p className={`${pageClassName}__container__item__title`}>
                        Last Updated
                    </p>
                    <p className={`${pageClassName}__container__item__value`}>
                        {isLoading ? (
                            <Skeleton height="small" />
                        ) : data?.result?.updatedAt ? (
                            formattedDateTime(data?.result?.updatedAt)
                        ) : (
                            "-"
                        )}
                    </p>
                </div>

                {data?.result?.users?.length !== 0 && (
                    <>
                        <Divider />
                        <div className={`${pageClassName}__users`}>
                            <p className={`${pageClassName}__users__title`}>Users</p>
                            <Table
                                header={tableHeader}
                                data={data?.result?.users ?? []}
                                loading={isLoading}
                                firstLoad={isLoading}
                                sortHandler={() => { }}
                                startIndex={1}
                                viewURL={ROUTE.OKTA_USER_LIST}
                                cursorPointer
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
export default SingleOktaDevice;
